import { Action } from 'redux'
import { CountryCode } from '../../../i18n/countryCodes'
import { ICountry } from '../../../models/Country'
import { CountryDictionary } from '../../../reducers/userObject/actionNames'

export const requestCountryDictionaryChange = (
  lang: CountryCode,
): ICountryDictionaryUpdate => ({
  lang,
  type: CountryDictionary.RequestUpdate,
})

export interface ICountryDictionaryUpdate
  extends Action<CountryDictionary.RequestUpdate> {
  lang: CountryCode
}

export const countryDictionaryAccepted = (
  dictionary: ICountry[],
): ICountryDictionaryAccepted => ({
  dictionary,
  type: CountryDictionary.DictionaryAccepted,
})

export interface ICountryDictionaryAccepted
  extends Action<CountryDictionary.DictionaryAccepted> {
  dictionary: ICountry[]
}
